import React, { Component } from 'react';
import { colors } from '@peachjar/components';
import {
  withStyles,
  MuiThemeProvider,
  createMuiTheme,
} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import Check from '@material-ui/icons/Done'; // Icon when locked
import CheckBoxChecked from '@material-ui/icons/CheckBox'; // Icon when not locked
import EnhancedTableHead from './EnhancedTableHead';

const { slate } = colors;

class EnhancedTable extends Component {
  componentDidMount() {
    const {
      data,
      areSchoolsActivated,
      handleSelectedLock,
    } = this.props;

    if (!areSchoolsActivated) {
      handleSelectedLock(data);
    }
  }

  isSelected = ({ id }) => Boolean(this.props.selected.find(s => s.id === id));

  render() {
    const {
      classes,
      order,
      orderBy,
      data,
      handleRequestSort,
      handleSelected,
      checkboxLock,
    } = this.props;

    return (
      <div
        className={classes.tableWrapper}
        style={{ border: '1px solid #e6e6e6', borderRadius: '3px' }}
      >
        <Table className={classes.table}>
          <EnhancedTableHead
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={data.length}
          />
          <TableBody>
            {data.map(school => {
              const isSelected = this.isSelected(school);
              return (
                <TableRow
                  hover
                  onClick={
                    checkboxLock
                      ? () => {}
                      : event => handleSelected(event, school)
                  }
                  role="checkbox"
                  aria-checked={isSelected}
                  tabIndex={-1}
                  key={school.id}
                  className={classes.row}
                >
                  <TableCell
                    style={{ textAlign: 'left', paddingLeft: '1rem' }}
                    component="th"
                    scope="row"
                    padding="none"
                  >
                    {school.name}
                  </TableCell>
                  <TableCell style={{ textAlign: 'left' }} numeric>
                    {school.id}
                  </TableCell>
                  <TableCell style={{ textAlign: 'left' }}>
                    {school.address}
                  </TableCell>
                  <TableCell style={{ textAlign: 'left' }}>
                    {school.enrollment}
                  </TableCell>
                  <TableCell style={{ textAlign: 'left' }}>
                    {school.grades}
                  </TableCell>
                  <TableCell style={{ textAlign: 'left' }}>
                    {school.level}
                  </TableCell>
                  <TableCell style={{ textAlign: 'left' }} padding="checkbox">
                    <MuiThemeProvider theme={theme}>
                      <Checkbox
                        icon={<CheckBoxOutlineBlank />}
                        checkedIcon={
                          checkboxLock ? (
                            <Check style={{ color: slate }} />
                          ) : (
                            <CheckBoxChecked />
                          )
                        }
                        hidden={this.props.areSchoolsActivated && !isSelected}
                        checked={isSelected}
                        color="primary"
                        disableRipple
                      />
                    </MuiThemeProvider>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    maxWidth: 1170,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#f5f5f5',
    },
  },
});

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#3a833c',
      dark: '#3a833c',
      light: '#3a833c',
      contrastText: '#3a833c',
    },
  },
});

export default withStyles(styles)(EnhancedTable);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/school/components/EnhancedTable.jsx